import Pronounce from './Pronounce';

export default Pronounce;
